import { configureStore } from "@reduxjs/toolkit";

//slices
import loginSlice from "./slices/loginSlice.js";
import systemSlice from "./slices/systemSlice.js";
import loadingSlice from "./slices/loadingSlice";
import globalErrorSlice from "./slices/globalErrorSlice.js";
import userSlice from "./slices/userSlice.js";
import countriesSlice from "./slices/countriesSlice.js";
import dictionarySlice from "./slices/dictionarySlice.js";
import tierSlice from "./slices/tierSlice.js";
import successSlice from "./slices/successSlice.js";
import citySlice from "./slices/citySlice.js";

//listeners
import allListener from "./listeners/allListener.js";
import loginListenMiddelware from "./listeners/loginSliceListeners.js";
import userListenMiddelware from "./listeners/userInfoListener.js";
import systemListenMiddelware from "./listeners/systemListeners.js";


const store = configureStore({
  reducer: {
    loginState: loginSlice,
    systemState: systemSlice,
    loadingState: loadingSlice,
    globalErrorState: globalErrorSlice,
    userState: userSlice,
    countriesState: countriesSlice,
    dictionaryState: dictionarySlice,
    tierState: tierSlice,
    successState: successSlice,
    citiesState: citySlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(allListener.middleware)
      .prepend(loginListenMiddelware.middleware)
      .prepend(userListenMiddelware.middleware)
      .prepend(systemListenMiddelware.middleware)
});

export default store;
